<div class="action-container desc">
  Realiza tu pago con tu tarjeta de crédito o débito
</div>
<app-card-image-list></app-card-image-list>

<div class="line-decorator"></div>

<div class="text-center">
  <div
    class="card-customer-container"
    *ngIf="flashPaymentService.controller.tokenCards.length !== 0"
  >
    <div class="text-container">
      <strong>Seleciona tu tarjeta haciendo click sobre ella, y luego haz click en el boton pagar</strong>
    </div>

    <div class="light-text">Utiliza tus métodos de pago almacenados</div>

    <div class="text-container">
      <strong>Mis Tarjetas</strong>
    </div>
  </div>
</div>

<div (click)="openForm = false">
  <app-card-carousel [canShowArrows]="cantShowArrows"></app-card-carousel>
</div>

<div [ngClass]="{ none: openForm, '': !openForm }">
  <div class="line-decorator" *ngIf="flashPaymentService.controller.tokenCards.length !== 0"></div>
  <div class="action-container" *ngIf="flashPaymentService.controller.tokenCards.length !== 0">

    <div class="action-container" *ngIf="flashPaymentService.controller.tokenInstrumentId  >0">
      <button class="btn btn-danger action-btn" (click)="pay()">
        Pagar &nbsp;{{flashPaymentService.controller.operationAmount | currency}}
      </button>
    </div>

    <div class="action-container" *ngIf="!flashPaymentService.controller.tokenInstrumentId">
      <button class="btn btn-secondary btn-off">Pagar &nbsp;{{flashPaymentService.controller.operationAmount | currency}}
      </button>
    </div>

    <div class="line-decorator" *ngIf="flashPaymentService.controller.tokenCards.length !== 0"></div>
  </div>
</div>

<div id="accordion2" class="new-container">
  <div class="form-title" (click)="changeIcon()">
    Pagar utilizando una nueva tarjeta
    <span>
        <img src="../../../../../assets/images/icon_menos.png" alt="" [ngClass]="{none: !openForm, '': openForm}"/>
        <img src="../../../../../assets/images/icon_mas.png" alt="" [ngClass]="{none: openForm,'': !openForm}"/>
      </span>
  </div>
  <div class="aux" [ngClass]="{show: openForm, none: !openForm}">
    <app-payment-form></app-payment-form>
  </div>
</div>
